import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $HelperContainerButtonClose = styled('div')`
  display: flex;
  justify-content: end;
`;

export const $HelperContainerTitle = styled('div')`
  margin-bottom: ${spacing('lg')};
  h2 {
    font-weight: ${fontWeight('bold')};
    @media ${media.maxWidth.sm} {
      ${fontStyle('xl')};
    }
  }
`;

export const $CloseButton = styled(Button)`
  padding: 0;

  &&:hover,
  &&:active,
  &&:focus {
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};

    & svg {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }

  && svg {
    width: ${spacing('xxl')};
    height: ${spacing('xxl')};
    max-height: none;
    max-width: none;
    margin-right: unset;
  }
`;

export const $HelperButton = styled(Button)`
  min-width: unset;
  overflow: unset;
  margin-bottom: ${spacing('sm')};
  color: ${({ theme }) => theme.colors.black};
  &&:hover,
  &&:active,
  &&:focus {
    color: ${({ theme }) => theme.colors.primary};
    background-color: unset;
  }
`;

export const $Img = styled.img`
  width: 100%;
`;
